import { render, staticRenderFns } from "./aijiedu.vue?vue&type=template&id=4170fd0a&scoped=true&"
import script from "./aijiedu.vue?vue&type=script&lang=js&"
export * from "./aijiedu.vue?vue&type=script&lang=js&"
import style0 from "./aijiedu.vue?vue&type=style&index=0&id=4170fd0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4170fd0a",
  null
  
)

export default component.exports